import {cx} from "@emotion/css";
import {useState} from "react";

import {isUndefined} from "@/shared/FunctionCore";
import {classCombinerFromPrefix} from "@/app/pages/upik/resources/RenderIdentifier";
import {PageUrlProps, UpikContainerProps} from "@/app/pages/upik/resources/interfacesData";
import * as  SearchTabsStyles from "@/app/pages/upik/styles/SearchTabsStyles.module.scss";
import {HowDoesDandBSupportUpikTab} from "@/app/pages/upik/components/HowDoesDandBSupportUpikTab";
import {SearchFormTab} from "@/app/pages/upik/components/SearchFormTab";
import {WhatDunsNumberTab} from "@/app/pages/upik/components/WhatDunsNumberTab";
import React from "react";
import { useLocation } from "react-router-dom";
import { bottomContentParagraphs, privateMessageContent } from "@/app/pages/upik/resources/content";

const styles = SearchTabsStyles;
const classCombiner = classCombinerFromPrefix("6e1124ea8c05f948");

const getTabLabel = (localizedTabTitle: string | undefined, defaultTabDisplayValue: string) => isUndefined(localizedTabTitle) ? defaultTabDisplayValue : localizedTabTitle;

type SearchTabsProps = PageUrlProps & UpikContainerProps;

const SearchTabs = (props: SearchTabsProps): JSX.Element => {
    const [tabName, setTabName] = useState("first");

    const tabsData = [
        {
            "id": "first",
            "label": getTabLabel(props.tabOneTitle, props.language === 'de' ? "UPIK<sup>®</sup> Plattform Suche" : "UPIK<sup>®</sup> Platform Search")
        },
        {
            "id": "second",
            "label": getTabLabel(props.tabTwoTitle, props.language === 'de' ? "Was ist die D&amp;B D-U-N-S<sup>®</sup> Nummer?" : "What is the D&B D-U-N-S<sup>®</sup> Number?")
        },
        {
            "id": "third",
            "label": getTabLabel(props.tabThreeTitle, props.language === 'de' ? "In welcher Weise unterstützt D&amp;B UPIK<sup>®</sup>?" : "How does D&B support UPIK<sup>®</sup>?")
        }
    ];

    const openTab = (tabId: string) => {
        setTabName(tabId);
    };

    const bottomContentParaOneLocalized = () =>{
        const location = useLocation();
        if(props.language === 'de' && location.pathname.includes("/onboarding") ){
            return bottomContentParagraphs.de.private.paraOne;
        }
        else if(props.language === 'de' && !location.pathname.includes("/onboarding") ){
            return bottomContentParagraphs.de.public.paraOne;
        } else if(props.language === 'en' && location.pathname.includes("/onboarding") ){
            return bottomContentParagraphs.en.private.paraOne;
        } else{
           return  bottomContentParagraphs.en.public.paraOne;
        }
    }



    const searchFormTabProps = {
        "bottomContentParaOneLocalized": bottomContentParaOneLocalized(),
        "bottomContentParaTwoLocalized": props.language === 'de' ? bottomContentParagraphs.de.paraTwo : bottomContentParagraphs.en.paraTwo,
        "cityLocalized": props.cityLocalized,
        "clearSearchLocalized": props.clearSearchLocalized,
        "companyAddressLocalized": props.companyAddressLocalized,
        "companyResultNoteLocalized": props.companyResultNoteLocalized,
        "dunsNumberLocalized": props.dunsNumberLocalized,
        "editDetailsLocalized": props.editDetailsLocalized,
        "formInstructionLocalized": props.formInstructionLocalized,
        "hereRedirectionLinkUrl": props.language === 'de' ? '/de-de/upik/kontaktaufnahme-upik.html' : '/de-de/upik-en/contact-upik.html',
        "infoContentLocalizedPara1": props.infoContentLocalizedPara1,
        "infoContentLocalizedPara2": props.infoContentLocalizedPara2,
        "infoContentLocalizedPara3": props.infoContentLocalizedPara3,
        "isPrivatePage": props.currentPagePath?.includes('volkswagen') ? true : false,
        "language": props.language,
        "noDataFoundMsgLocalized": props.noDataFoundMsgLocalized,
        "privateMsgLocalized": props.language === 'de' ? privateMessageContent.de.text : privateMessageContent.en.text,
        "privateMsgNoteLocalized": props.language === 'de' ? privateMessageContent.de.note : privateMessageContent.en.note,
        "searchButtonLocalized": props.searchButtonLocalized,
        "searchForCompanyLocalized": props.searchForCompanyLocalized,
        "searchHereLocalized": props.searchHereLocalized,
        "searchResultsLocalized": props.searchResultsLocalized,
        "streetLocalized": props.streetLocalized,
        "topLocalized": props.topLocalized,
        "uniquePartnerTitleLocalized": props.uniquePartnerTitleLocalized
    };

    function renderTab() {
        switch (tabName) {
            case "first": {
                return <SearchFormTab {...searchFormTabProps} />;
            }
            case "second": {
                return <div className={cx(classCombiner(styles, "tabContentContainer"))}>
                    <WhatDunsNumberTab
                        language={props.language}
                        answerOneTabTwoLocalized={props.answerOneTabTwoLocalized}
                        isFullwidthVideo={props.isFullwidthVideo}
                        questionOneTabTwoLocalized={props.questionOneTabTwoLocalized}
                        upikVideoId={props.upikVideoId}
                        upikVideoThumbnailImage={props.upikVideoThumbnailImage}
                    />
                       </div>;
            }
            case "third": {
                return <div className={cx(classCombiner(styles, "tabContentContainer"))}>
                    <HowDoesDandBSupportUpikTab
                        language={props.language}
                        answerOneTabThreeLocalized={props.answerOneTabThreeLocalized}
                        answerTwoTabThreeLocalized={props.answerTwoTabThreeLocalized}
                        questionOneTabThreeLocalized={props.questionOneTabThreeLocalized}
                        questionTwoTabThreeLocalized={props.questionTwoTabThreeLocalized}
                    />
                       </div>;
            }
            default: {
                return <SearchFormTab {...searchFormTabProps} />;
            }
        }
    }

    return (
        <div className={cx(classCombiner(styles, "upikSearchTabsContainer"))}>
            <div className={cx(classCombiner(styles, "upikTabsContainer"))}>
                {tabsData.map(tab =>
                    <button
                        className={cx(classCombiner(styles, "tabButtonClass"),
                            classCombiner(styles, tab["id"] === tabName ? "selectedTabButtonClassOne" : "tabButtonClass"))}
                        dangerouslySetInnerHTML={{"__html": tab.label}}
                        key={tab["label"]}
                        onClick={() => openTab(tab["id"])}
                        type="button"
                    />
                )}
            </div>

            {renderTab()}
        </div>
    );
};
export {SearchTabs};
